/* tslint:disable */
/* eslint-disable */
/**
 * Illio Wealth API
 * [Environment: dev], Manage your account, add trades, view portfolio performance and pnl
 *
 * The version of the OpenAPI document: 1.0
 * Contact: support@illio.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { AssetClassDto } from './asset-class-dto';
import { AssetSubClassDto } from './asset-sub-class-dto';
import { CurrencyDto } from './currency-dto';
import { IndustrySectorDto } from './industry-sector-dto';
import { SimpleUserDto } from './simple-user-dto';
import { SourceId } from './source-id';

/**
 * 
 * @export
 * @interface InstrumentDto
 */
export interface InstrumentDto {
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'description'?: string;
    /**
     * 
     * @type {AssetClassDto}
     * @memberof InstrumentDto
     */
    'assetClass': AssetClassDto;
    /**
     * 
     * @type {AssetSubClassDto}
     * @memberof InstrumentDto
     */
    'assetSubClass': AssetSubClassDto;
    /**
     * 
     * @type {IndustrySectorDto}
     * @memberof InstrumentDto
     */
    'industrySector'?: IndustrySectorDto;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'industry'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'country'?: string;
    /**
     * 
     * @type {CurrencyDto}
     * @memberof InstrumentDto
     */
    'currency': CurrencyDto;
    /**
     * 
     * @type {CurrencyDto}
     * @memberof InstrumentDto
     */
    'incomeCurrency'?: CurrencyDto;
    /**
     * 
     * @type {number}
     * @memberof InstrumentDto
     */
    'price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InstrumentDto
     */
    'nonMarket': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InstrumentDto
     */
    'deletable': boolean;
    /**
     * 
     * @type {SimpleUserDto}
     * @memberof InstrumentDto
     */
    'user'?: SimpleUserDto;
    /**
     * 
     * @type {number}
     * @memberof InstrumentDto
     */
    'pointValue': number;
    /**
     * 
     * @type {SourceId}
     * @memberof InstrumentDto
     */
    'sourceId': SourceId;
    /**
     * 
     * @type {SourceId}
     * @memberof InstrumentDto
     */
    'underlyingSourceId'?: SourceId;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'displayId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'expirationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'riskAssetClass'?: InstrumentDtoRiskAssetClassEnum;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'investmentVehicle'?: InstrumentDtoInvestmentVehicleEnum;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'listingCountry'?: InstrumentDtoListingCountryEnum;
    /**
     * 
     * @type {string}
     * @memberof InstrumentDto
     */
    'status': InstrumentDtoStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InstrumentDtoRiskAssetClassEnum {
    CashAndEquivalents = 'CashAndEquivalents',
    Equities = 'Equities',
    FixedIncome = 'FixedIncome',
    RealEstate = 'RealEstate',
    Alternatives = 'Alternatives',
    Commodities = 'Commodities',
    RealAssets = 'RealAssets',
    CryptoCurrencies = 'CryptoCurrencies',
    Futures = 'Futures',
    Adjustments = 'Adjustments',
    MixedAllocation = 'MixedAllocation',
    Fx = 'Fx'
}
/**
    * @export
    * @enum {string}
    */
export enum InstrumentDtoInvestmentVehicleEnum {
    Etf = 'ETF',
    Fund = 'Fund',
    Physical = 'Physical',
    Option = 'Option',
    Warrant = 'Warrant',
    Loan = 'Loan',
    Bonds = 'Bonds',
    MoneyMarket = 'MoneyMarket',
    Mortgage = 'Mortgage',
    Shares = 'Shares',
    PrefShares = 'PrefShares',
    HedgeFunds = 'HedgeFunds',
    PrivateEquity = 'PrivateEquity',
    VentureCapital = 'VentureCapital',
    SpecialityFunds = 'SpecialityFunds',
    FundOfFunds = 'FundOfFunds',
    CryptoCurrencies = 'CryptoCurrencies',
    Adjustment = 'Adjustment',
    Fees = 'Fees',
    Fx = 'FX',
    Subscription = 'Subscription',
    Cash = 'Cash',
    Future = 'Future',
    RealAssets = 'RealAssets',
    TermDeposit = 'TermDeposit',
    Fcn = 'Fcn',
    StructuredProduct = 'StructuredProduct',
    Cfd = 'CFD',
    FxFwd = 'FXFwd',
    Tarf = 'Tarf'
}
/**
    * @export
    * @enum {string}
    */
export enum InstrumentDtoListingCountryEnum {
    Af = 'AF',
    Ax = 'AX',
    Al = 'AL',
    Dz = 'DZ',
    As = 'AS',
    Ad = 'AD',
    Ao = 'AO',
    Ai = 'AI',
    Ag = 'AG',
    Ar = 'AR',
    Am = 'AM',
    Aw = 'AW',
    Au = 'AU',
    Xt = 'XT',
    Xe = 'XE',
    Xy = 'XY',
    At = 'AT',
    Az = 'AZ',
    Bs = 'BS',
    Bh = 'BH',
    Bd = 'BD',
    Bb = 'BB',
    By = 'BY',
    Be = 'BE',
    Bz = 'BZ',
    Bj = 'BJ',
    Bm = 'BM',
    Bt = 'BT',
    Bo = 'BO',
    Bq = 'BQ',
    Ba = 'BA',
    Bw = 'BW',
    Bv = 'BV',
    Br = 'BR',
    Io = 'IO',
    Bn = 'BN',
    Bg = 'BG',
    Bf = 'BF',
    Bi = 'BI',
    Cv = 'CV',
    Kh = 'KH',
    Cm = 'CM',
    Ca = 'CA',
    Ky = 'KY',
    Cf = 'CF',
    Td = 'TD',
    Cl = 'CL',
    Cn = 'CN',
    Cx = 'CX',
    Cc = 'CC',
    Co = 'CO',
    Km = 'KM',
    Cg = 'CG',
    Cd = 'CD',
    Ck = 'CK',
    Cr = 'CR',
    Ci = 'CI',
    Hr = 'HR',
    Cu = 'CU',
    Cw = 'CW',
    Cy = 'CY',
    Cz = 'CZ',
    Dk = 'DK',
    Xs = 'XS',
    Dj = 'DJ',
    Dm = 'DM',
    Do = 'DO',
    Ec = 'EC',
    Eg = 'EG',
    Eu = 'EU',
    Sv = 'SV',
    Xp = 'XP',
    Gq = 'GQ',
    Er = 'ER',
    Ee = 'EE',
    Sz = 'SZ',
    Et = 'ET',
    Fk = 'FK',
    Fo = 'FO',
    Fj = 'FJ',
    Fi = 'FI',
    Fr = 'FR',
    Gf = 'GF',
    Pf = 'PF',
    Tf = 'TF',
    Xr = 'XR',
    Ga = 'GA',
    Gm = 'GM',
    Ge = 'GE',
    De = 'DE',
    Gh = 'GH',
    Gi = 'GI',
    Gr = 'GR',
    Gl = 'GL',
    Gd = 'GD',
    Gp = 'GP',
    Gu = 'GU',
    Gt = 'GT',
    Gg = 'GG',
    Gn = 'GN',
    Gw = 'GW',
    Gy = 'GY',
    Ht = 'HT',
    Hm = 'HM',
    Va = 'VA',
    Hn = 'HN',
    Hk = 'HK',
    Hu = 'HU',
    Is = 'IS',
    In = 'IN',
    Id = 'ID',
    Ir = 'IR',
    Iq = 'IQ',
    Ie = 'IE',
    Im = 'IM',
    Il = 'IL',
    It = 'IT',
    Jm = 'JM',
    Jp = 'JP',
    Xh = 'XH',
    Je = 'JE',
    Jo = 'JO',
    Kz = 'KZ',
    Ke = 'KE',
    Ki = 'KI',
    Kp = 'KP',
    Kr = 'KR',
    Kw = 'KW',
    Kg = 'KG',
    La = 'LA',
    Lv = 'LV',
    Lb = 'LB',
    Ls = 'LS',
    Lr = 'LR',
    Ly = 'LY',
    Li = 'LI',
    Lt = 'LT',
    Lu = 'LU',
    Mo = 'MO',
    Mg = 'MG',
    Mw = 'MW',
    My = 'MY',
    Mv = 'MV',
    Ml = 'ML',
    Mt = 'MT',
    Mh = 'MH',
    Mq = 'MQ',
    Mr = 'MR',
    Mu = 'MU',
    Yt = 'YT',
    Mx = 'MX',
    Fm = 'FM',
    Md = 'MD',
    Mc = 'MC',
    Mn = 'MN',
    Me = 'ME',
    Ms = 'MS',
    Ma = 'MA',
    Mz = 'MZ',
    Mm = 'MM',
    Na = 'NA',
    Nr = 'NR',
    Np = 'NP',
    Nl = 'NL',
    Nc = 'NC',
    Nz = 'NZ',
    Ni = 'NI',
    Ne = 'NE',
    Ng = 'NG',
    Nu = 'NU',
    Nf = 'NF',
    Mk = 'MK',
    Mp = 'MP',
    No = 'NO',
    Om = 'OM',
    Pk = 'PK',
    Pw = 'PW',
    Ps = 'PS',
    Pa = 'PA',
    Pg = 'PG',
    Py = 'PY',
    Pe = 'PE',
    Ph = 'PH',
    Pn = 'PN',
    Pl = 'PL',
    Pt = 'PT',
    Pr = 'PR',
    Qa = 'QA',
    Re = 'RE',
    Ro = 'RO',
    Ru = 'RU',
    Rw = 'RW',
    Bl = 'BL',
    Sh = 'SH',
    Kn = 'KN',
    Lc = 'LC',
    Mf = 'MF',
    Pm = 'PM',
    Vc = 'VC',
    Ws = 'WS',
    Sm = 'SM',
    St = 'ST',
    Sa = 'SA',
    Sn = 'SN',
    Rs = 'RS',
    Sc = 'SC',
    Sl = 'SL',
    Sg = 'SG',
    Sx = 'SX',
    Sk = 'SK',
    Si = 'SI',
    Sb = 'SB',
    So = 'SO',
    Za = 'ZA',
    Gs = 'GS',
    Ss = 'SS',
    Es = 'ES',
    Lk = 'LK',
    Sd = 'SD',
    Sr = 'SR',
    Sj = 'SJ',
    Se = 'SE',
    Ch = 'CH',
    Sy = 'SY',
    Tw = 'TW',
    Tj = 'TJ',
    Tz = 'TZ',
    Th = 'TH',
    Tl = 'TL',
    Tg = 'TG',
    Tk = 'TK',
    To = 'TO',
    Tt = 'TT',
    Tn = 'TN',
    Tr = 'TR',
    Tm = 'TM',
    Tc = 'TC',
    Tv = 'TV',
    Ug = 'UG',
    Ua = 'UA',
    Ae = 'AE',
    Gb = 'GB',
    Uk = 'UK',
    Us = 'US',
    Um = 'UM',
    Uy = 'UY',
    Uz = 'UZ',
    Vu = 'VU',
    Ve = 'VE',
    Vn = 'VN',
    Vg = 'VG',
    Vi = 'VI',
    Wf = 'WF',
    Eh = 'EH',
    Ye = 'YE',
    Zm = 'ZM',
    Zw = 'ZW',
    Xf = 'XF',
    Xx = 'XX',
    Xa = 'XA',
    Xb = 'XB',
    Xc = 'XC',
    Xd = 'XD',
    Xg = 'XG',
    Xi = 'XI',
    Xj = 'XJ',
    Xk = 'XK',
    Xl = 'XL',
    Xm = 'XM',
    Xn = 'XN',
    Xo = 'XO',
    Xq = 'XQ'
}
/**
    * @export
    * @enum {string}
    */
export enum InstrumentDtoStatusEnum {
    Draft = 'DRAFT',
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
    Delisted = 'DELISTED',
    Suspended = 'SUSPENDED',
    Deprecated = 'DEPRECATED',
    Error = 'ERROR'
}


